import React from 'react';
import EquivalentesMexicanos from './EquivalentesMexicanos';

/**
 * EquivalencesBrowser - Sistema de Equivalentes Mexicanos
 *
 * Este componente muestra el nuevo sistema de equivalentes mexicanos
 * basado en el Sistema Mexicano de Alimentos Equivalentes (SMAE)
 * y adaptado para la cultura alimentaria de México.
 *
 * Características:
 * - Base de datos con alimentos mexicanos tradicionales
 * - Categorías según NOM
 * - Información nutricional completa
 * - Contexto cultural (región, temporada, costo)
 * - Búsqueda y filtrado avanzado
 * - UI moderna con Material 3 Expressive
 */
const EquivalencesBrowser = () => {
  return <EquivalentesMexicanos />;
};

export default EquivalencesBrowser;
